<template>
  <div>
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <h3 class="mb-0">Lista de Insumos</h3>
          <p class="text-sm text-muted mb-0">
            Menú Diario, por semana cerrada. La línea Foodcourt, que proyecta por rango de
            días, está en
            <router-link to="/insumos/foodcourt">Insumos › Foodcourt</router-link>.
          </p>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <el-table
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              row-key="id"
              :data="historicData"
            >
              <!--    <el-table-column type="selection"
                       align="left"
                       min-width="120px">
              </el-table-column>-->

              <!-- <el-table-column label="Alimento" min-width="220px" prop="meal_id" sortable>
                <template v-slot="{row}">
                  <div class="table-user">
                    <img :src="'https://app.manzanaverde.pe/'+row.image_url" alt />
                    {{ row ? row.name.toUpperCase() : ''}}
                  </div>
                </template>
              </el-table-column>-->
              <el-table-column label="Semana" prop="week" width="270px" min-width="200px" sortable>
                <template v-slot="{row}">{{row.week}}</template>
              </el-table-column>
              <el-table-column
                label="Catering"
                prop="name"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{row}">{{row.name}}</template>
              </el-table-column>
              <el-table-column label="Fecha" prop="name" width="270px" min-width="200px" sortable>
                <template
                  v-slot="{row}"
                >del {{ getfirstNLastDayWeek(row.date).first}} a {{ getfirstNLastDayWeek(row.date).last}}</template>
              </el-table-column>
              <el-table-column label="Reporte" prop="name" width="270px" min-width="200px" sortable>
                <template v-slot="{row}">
                  <base-button
                    type="danger"
                    :loading="row.id === loading_id"
                    @click="get_insumos_list(row.id,getfirstNLastDayWeek(row.date).firstDate,getfirstNLastDayWeek(row.date).lastDate,row.catering_id)"
                  >
                    <i class="far fa-file-pdf"></i> Descargar PDF
                  </base-button>
                  <base-button
                    class="mt-2"
                    type="primary"
                    :loading="row.id === loading_id2"
                    @click="get_insumos_excel(row.id,getfirstNLastDayWeek(row.date).firstDate,getfirstNLastDayWeek(row.date).lastDate,row.catering_id)"
                  >
                    <i class="far fa-file-excel"></i> Descargar XLS
                  </base-button>                  
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="Descargar PDF"
                prop="subgroup_id"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{row}">
                  <a :href="baseUrl+date+'/'+user.data.catering_id+'/'+row.id">
                    <base-button type="danger">
                      <i class="far fa-file-pdf"></i> Descargar
                    </base-button>
                  </a>

                </template>
              </el-table-column>-->
            </el-table>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import backofficeApi from "../../gateways/backoffice-api";

import axios from "axios";
import moment from "moment";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "element-ui";

export default {
  name: "starter-page",
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      loading_id: false,
      loading_id2: false,
      name: "",
      user: [],
      currentPage: 1,
      selectedRows: [],
      date: new Date().toISOString().substr(0, 10),
      subgroups: [],
      totalIngredients: [],
      ingredientsByMeal: [],
      meals: [],
      baseUrlSnack: [],
      meals_ordered: [],
      meals_ordered_var: [],
      historicData: [],
      dates: {
        simple: "2018-07-17",
      },
      baseUrl: null,
      ingredients: [],
    };
  },
  created() {
    this.get_historic_supplyLists();
  },
  watch: {},
  methods: {
    getfirstNLastDayWeek(curr) {
      // var curr =  Date.parse(curr);; // get current date
      // var curr = new Date(curr);
      // var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
      // var last = first + 6; // last day is the first day + 6

      // var firstday = new Date(curr.setDate(first)).toUTCString();
      // var lastday = new Date(curr.setDate(last)).toUTCString();

      const today = moment(curr);
      const firstday = today.clone().startOf("isoWeek");
      const lastday = today.clone().endOf("isoWeek");

      var obj = {
        first: moment(firstday).format("DD-MM-YY"),
        last: moment(lastday).format("DD-MM-YY"),
        firstDate: moment(firstday).format("YYYY-MM-DD"),
        lastDate: moment(lastday).format("YYYY-MM-DD"),
      };
      return obj;
    },
    get_historic_supplyLists() {
      axios
        .get("supply/historic")
        .then((response) => {
          this.historicData = response.data.historic;
        })
        .catch((error) => console.log(error));
    },
    get_insumos_list(row_id, $date_ini, $date_end, $catering_id) {
      this.loading_id = row_id;

      backofficeApi({
        url: "supply/generate_pdf2",
        responseType: "blob",
        method: "get",
        params: {
          date_ini: $date_ini,
          date_end: $date_end,
          catering_id: $catering_id,
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "insumos-" + moment(new Date()).format("YYYY-MM-DD") + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading_id = null;
        });
    },
    get_insumos_excel(row_id, $date_ini, $date_end, $catering_id) {
      this.loading_id2 = row_id;

      backofficeApi({
        url: "supply/generate_excel2",
        responseType: "blob",
        method: "get",
        params: {
          date_ini: $date_ini,
          date_end: $date_end,
          catering_id: $catering_id,
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "insumos-" + moment(new Date()).format("YYYY-MM-DD") + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading_id2 = null;
        });
    },    
  },
};
</script>
<style>
.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
